import React, { useState, useRef } from 'react';
import '../SonsMarins.scss';
import svgCarte from '../images/carte.svg';
import { donneesSonsMarins } from '../donneesSonsMarins';
import { dataSeaSounds } from '../dataSeaSounds';
import { BoutonSonMarin } from './BoutonSonMarin';
import { InfosBlock } from './InfosBlock';
import svgMiniBtn from '../images/mini-btn.svg';

export const ContainerSonsMarins = ({language}) => {
  const carteEl = useRef(null);
  const data = language === "en" ? dataSeaSounds : donneesSonsMarins;
  const [selected, setSelected] = useState(null);
  const [soundPlaying, setSoundPlaying] = useState(false);

  return (
    <div ref={carteEl} className="container-sons-marins">
      <img src={svgCarte} className="carte" alt="carte" />
      {data.map((don, i) => (
        <BoutonSonMarin
          key={i}
          id={don.id}
          x={don.x}
          y={don.y}
          img={don.img}
          name={don.name}
          selected={selected}
          setSelected={setSelected}
          setSoundPlaying={setSoundPlaying}
        />
      ))}

      {selected !== null
        ? (
          <InfosBlock
            selected={selected}
            setSelected={setSelected}
            donneesSonsMarins={data}
            donnee={data.filter(dSM => dSM.id === selected)[0]}
            soundPlaying={soundPlaying}
            setSoundPlaying={setSoundPlaying}
            language={language}
          />
        )
        : (
          <div className='no-selection-block'>
            <img src={svgMiniBtn} alt=""/>
            <div>
              {language === "en"
                ? "Click a button to hear the associated sound"
                : "Cliquez sur un bouton pour entendre le son associé"
              }
            </div>
          </div>
        )
      }
    </div>
  );
}